import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    content: {
      flexGrow: 1,
    },
    academyHomePageContent: {
      flexGrow: 1,
      overflowX: 'visible',
    },
  })
)
